import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon4.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer py-4 px-3">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/nottpande/"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://www.instagram.com/nottpande/"><img src={navIcon3} alt="Icon" /></a>
            </div>
            <p>Aditya Pande's Portfolio</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
